module.exports = __webpack_public_path__ + "static/media/eg.38eac4f3.svg";